exports.IDS = {
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 0,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  Type: {
    MATCHODDS: 1,
    BOOKMAKER: 2,
    TIEDMATCH: 3,
    SESSIONS: 4,
  },
  MarketType: {
    BetFair: 1,
    Diamond: 2,
  },
  BetType: {
    Back: 1,
    Lay: 2,
  },
  Roles: {
    Admin: 1,
    SuperSuperMaster: 2,
    SuperMaster: 3,
    Master: 4,
    Client: 5,
  },
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
  MatchStatus: {
    STARTED: 1,
    NOT_STARTED: 2,
    FINISHED: 3,
  },
  MarketsStatus: {
    OPEN: "OPEN",
    SUSPENDED: "SUSPENDED",
    CLOSED: "CLOSED",
  },
  RunnersStatus: {
    NULL: "",
    ACTIVE: "ACTIVE",
    WINNER: "WINNER",
    LOSER: "LOSER",
    REMOVED: "REMOVED",
  },

  ResultsTypeId: {
    ACTIVE: 1,
    WINNER: 2,
    LOSER: 3,
    REMOVED: 4,
  },
  GType: {
    // Odds Rs 500
    match1: { name: "match1", odds_condition: false, odds: true },

    // Odds condition 100
    fancy: { name: "fancy", odds_condition: true, odds: true },
    fancy1: { name: "fancy1", odds_condition: false, odds: true },
    khado: { name: "khado", odds_condition: true, odds: true },
    meter: { name: "meter", odds_condition: true, odds: true },

    // Remaing odds 1.95
    oddeven: { name: "oddeven", odds_condition: false, odds: true },
  },
  // entity sport

  SessionsType: {
    Run: "Run",
    Boundaries: "Boundaries",
    Balls: "Balls",
    Wicket: "Wicket",
    DotBall: "Dot ball",
    HighestScoring: "Highest Scoring",
    Six: "Six",
    Four: "Four",
    Duck: "Duck",
    50: "50",
    30: "30",
    Runout: "Runout",
    LBW: "LBW",
    Bowled: "Bowled",
    Caught: "Caught",
    Extra: "Extra",
    Wide: "Wide",
    Run2: "2 Run",
    Run1: "1 Run",
    Other: "",
  },

  Ballevents: {
    PlayersEnter: { code: 1, description: "Players Enter" },
    NewBatter: { code: 2, description: "New Batter" },
    NewBowler: { code: 3, description: "New Bowler" },
    CatchDrop: { code: 4, description: "Catch Drop" },
    Misfield: { code: 5, description: "Misfield" },
    BoundaryCheck: { code: 6, description: "Boundary Check" },
    ThirdUmpire: { code: 7, description: "3rd umpire" },
    ThirdUmpireOut: { code: 8, description: "3rd umpire out" },
    ThirdUmpireNotOut: { code: 9, description: "3rd umpire not out" },
    Review: { code: 10, description: "Review" },
    Injured: { code: 11, description: "Injured" },
    MaidenOver: { code: 12, description: "Maiden over" },
    WicketCheck: { code: 13, description: "Wicket Check" },
    StumpCheck: { code: 14, description: "Stump Check" },
    CatchCheck: { code: 15, description: "Catch Check" },
    FirstBounce: { code: 16, description: "1st Bounce" },
    SecondBounce: { code: 17, description: "2nd Bounce" },
    FastBowler: { code: 18, description: "Fast Bowler" },
    SpinBowler: { code: 19, description: "Spin Bowler" },
    Appeal: { code: 20, description: "Appeal" },
    BallInAir: { code: 21, description: "Ball In Air" },
    BowlerStop: { code: 22, description: "Bowler Stop" },
    Over: { code: 23, description: "Over" },
    BallChalu: { code: 24, description: "Ball Chalu" },
    Wicket: { code: 25, description: "Wicket" },
    Dot: { code: 26, description: "Dot" },
    Wide: { code: 27, description: "Wide" },
    NoBall: { code: 28, description: "No Ball" },
    Bye: { code: 29, description: "Bye" },
    LegBye: { code: 30, description: "Leg Bye" },
    Four: { code: 31, description: "Four" },
    Six: { code: 32, description: "Six" },
    RetiredHurt: { code: 34, description: "Retired Hurt" },
    Run1: { code: 35, description: "1 run" },
    Run2: { code: 36, description: "2 run" },
    Run3: { code: 37, description: "3 run" },
    Run4: { code: 38, description: "4 run" },
    Run5: { code: 39, description: "5 run" },
    Run6: { code: 40, description: "6 run" },
    Run7: { code: 41, description: "7 run" },
    Bowled: { code: 42, description: "Bowled" },
    Caught: { code: 43, description: "Caught" },
    LBW: { code: 44, description: "LBW" },
    Stumped: { code: 45, description: "Stumped" },
    RunOut: { code: 46, description: "Run Out" },
    HitWicket: { code: 47, description: "Hit Wicket" },
    RetiredOut: { code: 48, description: "Retired Out" },
    ObstructingField: { code: 49, description: "Obstructing The Field" },
    TimedOut: { code: 50, description: "Timed Out" },
    Toss: { code: 51, description: "Toss" },
    Delayed: { code: 52, description: "Delayed" },
    DrinksBreak: { code: 53, description: "Drinks Break" },
    InningBreak: { code: 54, description: "Inning Break" },
    Stumps: { code: 55, description: "Stumps" },
    LunchBreak: { code: 56, description: "Lunch Break" },
    TeaBreak: { code: 57, description: "Tea Break" },
    MatchStartDelay: { code: 58, description: "Match Start Delay" },
    RainDelay: { code: 59, description: "Rain Delay" },
    Dinner: { code: 60, description: "Dinner" },
    StrategicTimeout: { code: 61, description: "Strategic Timeout" },
    TechnicalIssue: { code: 62, description: "Technical Issue" },
    BadLight: { code: 63, description: "Bad Light" },
    MatchInterrupted: { code: 64, description: "Match Interrupted" },
    TossUpdate: { code: 65, description: "Toss Update" },
    Playing11Update: { code: 66, description: "Playing-11 Update" },
    MatchEnd: { code: 67, description: "Match End" },
    FielderInjured: { code: 68, description: "Fielder Injured" },
    BatterInjured: { code: 69, description: "Batter Injured" },
    BowlerInjured: { code: 70, description: "Bowler Injured" },
    RunoutCheck: { code: 71, description: "Runout Check" },
    FreeHit: { code: 72, description: "Free Hit" },
    Overthrow: { code: 73, description: "Overthrow" },
    NoBallCheck: { code: 74, description: "No Ball Check" },
    WideBallCheck: { code: 75, description: "Wide Ball Check" },
    LBWCheck: { code: 76, description: "LBW Check" },
    BattingReview: { code: 77, description: "Batting Review" },
    BowlingReview: { code: 78, description: "Bowling Review" },
  },

  CompetitionStatusCodes: {
    Upcoming: "upcoming",
    Result: "result",
    Live: "live",
  },

  MatchStatusCodes: {
    Scheduled: { code: 1, description: "Scheduled" },
    Completed: { code: 2, description: "Completed" },
    Live: { code: 3, description: "Live" },
    Abandoned: { code: 4, description: "Abandoned, canceled, no result" },
  },

  InningsStatusCodes: {
    Scheduled: { code: 1, description: "Scheduled" },
    Completed: { code: 2, description: "Completed" },
    Live: { code: 3, description: "Live" },
    Abandoned: { code: 4, description: "Abandoned" },
  },

  InningResultCodes: {
    Default: { code: 0, description: "Default" },
    AllOut: { code: 1, description: "All Out" },
    Declared: { code: 2, description: "Declared" },
    TargetReached: { code: 3, description: "Target Reached" },
    OverReached: { code: 4, description: "Over Reached" },
  },

  WagonAndCommentaryCodes: {
    Available: { code: 1, description: "Available" },
    NotAvailable0: { codes: 0, description: "Not Available" },
    NotAvailable2: { codes: 2, description: "Not Available" },
  },

  MatchGameStateCodes: {
    Default: { code: 0, description: "Default" },
    StartsShortly: { code: 1, description: "Starts Shortly" },
    Toss: { code: 2, description: "Toss" },
    PlayOngoing: { code: 3, description: "Play Ongoing" },
    Delayed: { code: 4, description: "Delayed" },
    DrinksBreak: { code: 5, description: "Drinks Break" },
    InningsBreak: { code: 6, description: "Innings Break" },
    Stumps: { code: 7, description: "Stumps" },
    LunchBreak: { code: 8, description: "Lunch Break" },
    TeaBreak: { code: 9, description: "Tea Break" },
    MatchStartDelay: { code: 10, description: "Match Start Delay" },
    RainDelay: { code: 11, description: "Rain Delay" },
    Dinner: { code: 12, description: "Dinner" },
    StrategicTimeout: { code: 13, description: "Strategic Timeout" },
    TechnicalIssue: { code: 14, description: "Technical Issue" },
    BadLight: { code: 15, description: "Bad Light" },
    MatchInterrupted: { code: 16, description: "Match Interrupted" },
  },

  MatchFormatCodes: {
    ODI: { code: 1, description: "ODI (One Day International)" },
    TEST: { code: 2, description: "TEST" },
    T20I: { code: 3, description: "T20I (Twenty20 International)" },
    ListA: { code: 4, description: "List A (Limited Over Domestic Match)" },
    FirstClass: { code: 5, description: "First Class" },
    T20Domestic: { code: 6, description: "T20 (Domestic)" },
    WomenODI: { code: 7, description: "Women ODI" },
    WomenT20: { code: 8, description: "Women T20" },
    YouthODI: { code: 9, description: "Youth ODI" },
    YouthT20: { code: 10, description: "Youth T20" },
    Other: { code: 11, description: "Other" },
    OtherListA: { code: 12, description: "Other List A" },
    OtherFirstClass: { code: 13, description: "Other 1st Class" },
    OtherT20: { code: 14, description: "Other T20" },
    YouthTest: { code: 15, description: "Youth Test" },
    WomenTest: { code: 16, description: "Woman Test" },
    T10: { code: 17, description: "T10" },
    T100: { code: 18, description: "T100" },
    WomenT100: { code: 19, description: "Women T100" },
    TB10: { code: 20, description: "TB-10" },
  },

  MatchDomesticCodes: {
    International: { code: 0, description: "International Match" },
    Domestic: { code: 1, description: "Domestic Match" },
  },

  MatchTossDecision: {
    Batting: { code: 1, description: "Batting" },
    Fielding: { code: 2, description: "Fielding" },
  },

  PlayingRoleParameter: {
    bat: { code: "bat", description: "Batsman" },
    bowl: { code: "bowl", description: "Bowler" },
    all: { code: "all", description: "All Rounder" },
    wk: { code: "wk", description: "Wicketkeeper" },
    wkbat: { code: "wkbat", description: "Wicketkeeper" },
  },

  MatchSquadRoleParameter: {
    bat: { code: "bat", description: "Batsman" },
    bowl: { code: "bowl", description: "Bowler" },
    all: { code: "all", description: "All Rounder" },
    WK: { code: "WK", description: "Wicketkeeper" },
    cap: { code: "cap", description: "Captain of playing XI" },
    wkcap: { code: "wkcap", description: "Wicketkeeper and captain" },
    squad: {
      code: "squad",
      description: "Player is not selected in Playing XI and benched",
    },
  },

  InternationalTeamId: {
    Afghanistan: { name: "Afghanistan", id: 498 },
    Australia: { name: "Australia", id: 5 },
    AustraliaWomen: { name: "Australia Women", id: 8652 },
    Bangladesh: { name: "Bangladesh", id: 23 },
    BangladeshWomen: { name: "Bangladesh Women", id: 10712 },
    England: { name: "England", id: 490 },
    EnglandWomen: { name: "England Women", id: 9534 },
    India: { name: "India", id: 25 },
    IndiaWomen: { name: "India Women", id: 9536 },
    Ireland: { name: "Ireland", id: 11 },
    IrelandWomen: { name: "Ireland Women", id: 10511 },
    NewZealand: { name: "New Zealand", id: 7 },
    NewZealandWomen: { name: "New Zealand Women", id: 8650 },
    Pakistan: { name: "Pakistan", id: 13 },
    PakistanWomen: { name: "Pakistan Women", id: 10259 },
    SouthAfrica: { name: "South Africa", id: 19 },
    SouthAfricaWomen: { name: "South Africa Women", id: 10279 },
    SriLanka: { name: "Sri Lanka", id: 21 },
    SriLankaWomen: { name: "Sri Lanka Women", id: 10277 },
    WestIndies: { name: "West Indies", id: 17 },
    WestIndiesWomen: { name: "West Indies Women", id: 10272 },
    Zimbabwe: { name: "Zimbabwe", id: 493 },
    ZimbabweWomen: { name: "Zimbabwe Women", id: 14619 },
    Scotland: { name: "Scotland", id: 9 },
    ScotlandWomen: { name: "Scotland Women", id: 14624 },
    Netherlands: { name: "Netherlands", id: 1824 },
    NetherlandsWomen: { name: "Netherlands Women", id: 14627 },
    Kenya: { name: "Kenya", id: 9160 },
    Fiji: { name: "Fiji", id: 9140 },
    Namibia: { name: "Namibia", id: 10798 },
    Nepal: { name: "Nepal", id: 10814 },
    NepalWomen: { name: "Nepal Women", id: 26768 },
    HongKong: { name: "Hong Kong", id: 1544 },
    HongKongWomen: { name: "Hong Kong Women", id: 26771 },
    Oman: { name: "Oman", id: 1546 },
    Canada: { name: "Canada", id: 6791 },
    UnitedArabEmirates: { name: "United Arab Emirates", id: 15 },
  },

  MatchResultCodes: {
    None: { code: 0, description: "none" },
    Team1Wins: { code: 1, description: "Team1 Wins" },
    Team2Wins: { code: 2, description: "Team2 Wins" },
    Drawn: { code: 3, description: "Drawn" },
    NoResult: { code: 4, description: "No Result" },
    Tie: { code: 5, description: "Tie" },
    Cancelled: { code: 6, description: "Cancelled" },
  },

  WeatherType: {
    Ash: { code: "Ash", description: "Volcanic activity" },
    Clear: { code: "Clear", description: "Cloudless sky, bright sunlight" },
    Clouds: { code: "Clouds", description: "Cloudy weather" },
    Drizzle: { code: "Drizzle", description: "Light and fine raindrops" },
    Dust: {
      code: "Dust",
      description: "Air is filled with suspended particles of dust and sand",
    },
    Fog: { code: "Fog", description: "Thick layer of tiny water droplets" },
    Haze: {
      code: "Haze",
      description:
        "Composed of tiny particles, such as dust, smoke, or pollutants",
    },
    Mist: { code: "Mist", description: "Thin and fine water vapor" },
    Rain: {
      code: "Rain",
      description: "Liquid water droplets fall from clouds",
    },
    Sand: { code: "Sand", description: "Fine particles of sand in the air" },
    Smoke: {
      code: "Smoke",
      description: "Air is filled with suspended particles and gases",
    },
    Snow: {
      code: "Snow",
      description:
        "Water vapor in the form of ice crystals falls from the clouds",
    },
    Squall: { code: "Squall", description: "Strong and gusty winds" },
    Thunderstorm: {
      code: "Thunderstorm",
      description: "Lightning, thunder, heavy rainfall",
    },
    Tornado: { code: "Tornado", description: "Rotating columns of air" },
  },

  GroundCondition: {
    PitchCondition: {
      GreenPitch: {
        name: "Green Pitch",
        description: "There are grass on the pitch.",
      },
      FlatTrackPitch: {
        name: "Flat Track Pitch",
        description: "There is not grass or cracks on the pitch.",
      },
      SlowDustyPitch: {
        name: "Slow & Dusty Pitch",
        description: "Pitch is slow and dusty (easy wear and tear).",
      },
      FastBouncy: {
        name: "Fast & Bouncy",
        description: "Pitch is fast and Bouncy.",
      },
      DustyPitch: {
        name: "Dusty Pitch",
        description: "There is dust on the pitch.",
      },
      SpinningPitch: {
        name: "Spinning Pitch",
        description: "Pitch has a character which will help ball to spin.",
      },
    },
    BattingCondition: {
      Average: {
        name: "Average",
        description: "The condition for batting is average.",
      },
      HighScoring: {
        name: "High Scoring",
        description: "The condition is batting friendly.",
      },
      LowScoring: {
        name: "Low Scoring",
        description: "The condition is bowling friendly.",
      },
    },
    PaceBowlingCondition: {
      Average: {
        name: "Average",
        description: "This is average for Pace bowlers.",
      },
      PaceAndBounce: {
        name: "Pace and Bounce",
        description: "There is pace and bounce in the pitch.",
      },
      SwingFavourable: {
        name: "Swing Favourable",
        description: "There is condition favourable for the swing.",
      },
    },
  },
};
